import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface AlertStat {
  value: string | number;
  label: string;
}

interface AlertBannerProps {
  show: boolean;
  gradient: string;
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  stats?: AlertStat[];
  actionLabel?: string;
  onAction?: () => void;
}

const AlertBanner: React.FC<AlertBannerProps> = ({
  show,
  gradient,
  icon,
  title,
  subtitle,
  stats = [],
  actionLabel,
  onAction,
}) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        background: gradient,
        borderRadius: '12px',
        p: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ color: 'white', display: 'flex', alignItems: 'center' }}>{icon}</Box>
        <Box>
          <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '15px', fontFamily: "'Montserrat', sans-serif" }}>
            {title}
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px', fontFamily: "'Montserrat', sans-serif" }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        {stats.map((stat) => (
          <Box key={stat.label} sx={{ textAlign: 'center' }}>
            <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '20px', fontFamily: "'Montserrat', sans-serif" }}>
              {stat.value}
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '10px', textTransform: 'uppercase', fontFamily: "'Montserrat', sans-serif" }}>
              {stat.label}
            </Typography>
          </Box>
        ))}
        {actionLabel && onAction && (
          <Button
            variant="contained"
            size="small"
            onClick={onAction}
            sx={{
              bgcolor: 'rgba(255,255,255,0.2)',
              color: 'white',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            {actionLabel}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default AlertBanner;
